import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '@app/auth/services';
import { Store } from '@ngrx/store';
import * as fromAuthStore from 'src/app/auth/store';
import { ROUTES } from 'src/utils/constants';

@Component({
  selector: 'app-auth-success-message',
  templateUrl: './auth-success-message.component.html',
  styleUrls: ['./auth-success-message.component.scss'],
})
export class AuthSuccessMessageComponent implements OnInit {
  @Input()
  status: string;

  constructor(
    private _AuthService: AuthService,
    private authStore: Store<fromAuthStore.State>
  ) {}

  ngOnInit(): void {
    if (this.status === 'registration-success') {
      this.authStore.dispatch(new fromAuthStore.GetRoles());
      this.authStore.dispatch(new fromAuthStore.GetCurrentUser());
    }
  }

  goToProfile() {
    this._AuthService.redirectToOtherApp(ROUTES.PROFILE.MY);
  }
}
